<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content point-settings">
    <div slot="header">
      <window-header cmp-title="Point clouds" widget-name="pc_layers"></window-header>
    </div>
    <div class="card-body flex-full-height p-2">
      <div role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion1>Pointclouds</b-btn>
          </b-card-header>
          <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-form-group >
                <b-form-checkbox-group stacked v-model="selected" name="flavour2" :options="pc" class="p-1">
                </b-form-checkbox-group>
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion3>Onsurface layers</b-btn>
          </b-card-header>
          <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-form-group >
                <b-form-checkbox-group stacked v-model="selectedOnl" :options="onl" class="p-1">
                </b-form-checkbox-group>
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion2>Subsurface layers</b-btn>
          </b-card-header>
          <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-form-group >
                <b-form-checkbox-group stacked v-model="selectedSl" :options="sl" class="p-1">
                </b-form-checkbox-group>
              </b-form-group>

            </b-card-body>
          </b-collapse>
        </b-card>

        <!--<b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion4>Vector layers</b-btn>
          </b-card-header>
          <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel"  class="p-2">
            <b-card-body>
              <b-form-group >
                <b-form-checkbox-group stacked v-model="selectedVl" :options="vl" class="p-1">
                </b-form-checkbox-group>
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>-->
      </div>

    </div>
  </b-card>
</template>

<script>
  import WindowHeader from '../common/WindowHeader'
  export default {
    name: 'PointCloudLayers',
    components: {WindowHeader},
    data () {
      return {
        selected: [],
        selectedSl: [],
        selectedOnl: [],
        selectedVl: [],
        pc: [
          {
            value: 'quadrants-da1',
            text: 'DA1',
            disabled: false
          },
          {
            value: 'quadrants-da2',
            text: 'DA2',
            disabled: false
          },
          {
            value: 'quadrants',
            text: 'DA5',
            disabled: false
          },
          {
            value: ['quadrants-da72'],
            text: 'DA7',
            disabled: false
          },

          {
            value: ['quadrants-da8-1'],
            text: 'DA8-1',
            disabled: false
          },
          {
            value: ['quadrants-da8-2'],
            text: 'DA8-2',
            disabled: false
          },
          {
            value: [ 'quadrants-da8-3' ],
            text: 'DA8-3',
            disabled: false
          },
          {
            value: [ 'quadrants-da8-5' ],
            text: 'DA8-5',
            disabled: false
          },
          {
            value: ['quadrants-da8-6' ],
            text: 'DA8-6',
            disabled: false
          },
        ],
        sl: [],
        onl: [],
        vl: []
      }
    },
    computed: {

    },
    created () {
      this.$potreeService.wmsLayers.filter(w => w.tileType === 'subsurface').forEach(l => {
        this.sl.push(
          {
            value: l.name,
            text: l.name,
            disabled: !l.enabled
          }
        )
      })

      this.sl.unshift({
        value: 'subsurface',
        text: 'Coal depth base'
      })

      this.$potreeService.wmsLayers.filter(w => w.tileType === 'terrain').forEach(l => {
        this.onl.push(
          {
            value: l.name,
            text: l.name,
            disabled: !l.enabled
          }
        )
      })

      this.onl.unshift({
        value: 'terrain',
        text: 'Terrain base'
      })

      this.$potreeService.vectorLayers.forEach(l => {
        this.sl.push({
          value: l.name,
          text: l.name,
          disabled: false
        })
      })

    },
    mounted () {
      let names = this.pc.map(p => p.value)
      window.viewer.scene.pointclouds.forEach(p => {
        let index = names.indexOf(p.name)
        if (index > -1) {
          this.selected.push(p.name)
        }
      })

      this.selectedSl.push('subsurface')
      this.$potreeService.wmsLayers.filter(w => w.tileType === 'subsurface').forEach(w => this.selectedSl.push(w.name))

      this.selectedOnl.push('terrain')
      this.$potreeService.wmsLayers.filter(w => w.tileType === 'terrain').forEach(w => this.selectedOnl.push(w.name))

      this.$potreeService.vectorLayers.forEach(v => {
        this.selectedSl.push(v.name)
      })

    },
    watch: {
      selectedSl (val) {

        let rasterLayers = []
        let vectorLayers = []
        let vs = this.$potreeService.vectorLayers.map(v => v.name)

        val.forEach(v => {
          if (vs.indexOf(v) === -1) {
            rasterLayers.push(v)
          } else {
            vectorLayers.push(v)
          }
        })

        /*let rasterLayers = val.filter(v => {
          return v.type === 'raster'
        }).map(v => v.name)
        let vectorLayers = val.filter(v => v.type === 'vector').map(v => v.name)*/

        this.syncWmsLayers(rasterLayers, 'subsurface')
        this.syncVectorLayers(vectorLayers)
      },
      selectedOnl (val) {
        this.syncWmsLayers(val, 'terrain')
      },
      selected (val) {
        let names = window.viewer.scene.pointclouds.map(p => p.name)
        let selectedPc = []
        val.forEach(v => {
          if (typeof v === 'string'){
            selectedPc.push(v)
          } else {
            selectedPc = selectedPc.concat(v)
          }
        })


        selectedPc.forEach(p => {
          let index = names.indexOf(p)
          if (index === -1) {
            this.addPc(p)
          }
        })


        names.forEach(n => {
          let index = selectedPc.indexOf(n)
          if (index === -1) {
            this.removePc(n)
          }
        })

      }
    },
    methods: {
      syncVectorLayers (val) {
        val.forEach(v => {
          let l = this.$potreeService.vectorLayers.filter(vv => vv.name === v)[0]
          if (!l.enabled) {
            if (l.type === 'line') {
              this.$potreeService.createLineLayer(l.name, l.workpack_id, l.color)
            }

          }
        })

        this.$potreeService.vectorLayers.forEach(p => {
          let index = val.indexOf(p.name)
          if (index === -1) {
            this.$potreeService.removeVectorLayer.call(this.$potreeService, p)
          }
        })

      },
      syncWmsLayers (val, tileType) {

        let subsurface = val.filter(v => v === tileType)[0]
        if (!subsurface) {
          if (tileType === 'terrain') {
            this.$potreeService.drawTerrain = false
            this.onl.filter(w => w.value !== tileType)
              .forEach(w => {
                w.disabled = true
              })
          }
          if (tileType === 'subsurface') {
            this.$potreeService.drawSubsurface = false
            this.sl.filter(w => w.value !== tileType)
              .forEach(w => {
                w.disabled = true
              })
          }
        } else {
          if (tileType === 'terrain') {
            this.$potreeService.drawTerrain = true
            this.onl.filter(w => w.value !== tileType)
              .forEach(w => {
                w.disabled = false
              })
          }
          if (tileType === 'subsurface') {
            this.$potreeService.drawSubsurface = true
            this.sl.filter(w => w.value !== tileType)
              .forEach(w => {
                w.disabled = false
              })
          }
        }

        val.forEach(v => {
          this.$potreeService.wmsLayers.filter(w => w.tileType === tileType)
            .filter(w => w.name === v)
            .forEach(w => {
              w.enabled = true
            })
        })

        this.$potreeService.wmsLayers.filter(w => w.tileType === tileType)
          .forEach(w => {
            let index = val.indexOf(w.name)
            if (index === -1) {
              w.enabled = false
            }
          })

        this.$potreeService.redrawTiles()
      },
      getProxyUrl () {
        return location.protocol + '//' + location.host + '/api/greyhound'
      },
      addPc (name) {
        this.$store.commit('map/loadingTiles', 1)
        Potree.loadPointCloud(`greyhound://${this.getProxyUrl()}/resource/${name}/`, name, (e) => {
          this.$store.commit('map/reduceLoadingTiles', 1)
          if (e.type === 'pointcloud_loaded') {
            console.log(`successfully loaded ${name}`)
            viewer.scene.addPointCloud(e.pointcloud)
            e.pointcloud.material.size = 1
          } else {
            console.log(`failed to load pointcloud ${resource}`)
            console.error(e)
          }
        })
      },
      removePc (name) {
        let names = window.viewer.scene.pointclouds.map(p => p.name)
        let index = names.indexOf(name)
        if (index > -1) {
          window.viewer.scene.scenePointCloud.remove(window.viewer.scene.pointclouds[index])
          window.viewer.scene.pointclouds.splice(index, 1)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/PointCloudLayers.vue